import Vue from 'vue';
import VueRouter from 'vue-router';
import index from '../views/index';
import { defaultFarmId } from "../config/constant";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "hash",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      // beforeEnter: (to, from, next) => {
      //   const farmId = to.query.farmId;
      //   // 当 URL 中的 farmId 参数存在时
      //   if (farmId) {
      //     localStorage.setItem("farmId", farmId);
      //     next();
      //   }
      //   // 当 URL 中的 farmId 参数不存在时
      //   else {
      //     // 判断 localStorge 中 是否缓存了 farmId参数
      //     const cacheFarmId = localStorage.getItem("farmId");
      //     // 缓存了，跳转到对应农场
      //     if (cacheFarmId) {
      //       next({
      //         path: "/",
      //         query: {
      //           farmId: cacheFarmId
      //         }
      //       });
      //     }
      //     // 未缓存，跳转到默认农场
      //     else {
      //       localStorage.clear();
      //       localStorage.setItem("farmId", defaultFarmId);
      //       next({
      //         path: "/",
      //         query: {
      //           farmId: defaultFarmId
      //         }
      //       });
      //     }
      //   }
      // }
    },
  ]
});
